import { mapState } from 'vuex'

import Icon from '@/components/icon'
import Heading from '@/components/heading/heading'

export default {
  components: {
    appIcon: Icon,
    appHeading: Heading
  },
  props: {
    type: {
      default: 'default',
      type: String
    }
  },
  computed: {
    ...mapState('tours', ['details', 'address', 'fullAddress'])
  },
  methods: {
    yesOrNo (value) {
      if (!value) {
        return 'No'
      }

      return 'Yes'
    }
  }
}
